<template>
    <div class="bg-black">
        <div  class="footbox">
            <div class="f-row-b align-start">
                <div class="f-row-l f-l">
                    <!-- <div class="mr-3">
                        <div class="f-row-c">
                            <div class="img1">
                                <img src="../../assets/img/qrcode.png" alt="" />
                            </div>
                        </div>
                        <div class="text-c">关注微信公众号</div>
                    </div> -->

                    <div class="imgbox">
                        <img src="../../assets/img/foot-2.png" alt="" />
                    </div>
                    <div class="imgbox img2">
                        <img src="../../assets/img/foot-3.png" alt="" />
                    </div>
                    <div class="border"></div>
                    <div class="font-14 text-l">
                        <div>主办单位：{{config.unit}}</div>
                        <div class="mt1-05">地址：{{config.site}}</div>
                        <div class="mt1-05">传真：{{config.postcode}}</div>
                        <!-- <div class="mt1-05">邮箱：{{config.reportEmail}}</div> -->
                        <div class="mt1-05">Copyright © 2012 All Rights Reserved. Designed</div>
                        <div class="mt1-05">技术支持：{{config.copyright}}</div>
                    </div>
                </div>
                <div class="">
                    <!-- <div class="imgbox f-row-c">
                        <img src="../../assets/img/foot-4.png" alt="" />
                    </div> -->
                    <div class="f-row-l">直属机关纪委</div>
                    <div class="font-14 op-5">
                        <div class="mt-1 f-row-l">举报邮箱：{{config.reportEmail}}</div>
                         <div class="mt1-05 f-row-l">举报电话：{{config.reportPhone}}</div>
                    </div>

                </div>
                <div class="ml-1">
                    <!-- <div class="imgbox f-row-c">
                        <img src="../../assets/img/foot-5.png" alt="" />
                    </div> -->
                    <div class="f-row-l">纪检监察组</div>
                    <div class="font-14 op-5">
                        <div class="mt-1 f-row-l">举报网址：{{config.reportEmails}}</div>
                        <div class="mt1-05 f-row-l">举报电话：{{config.reportPhones}}</div>
                    </div>

                </div>
            </div>
        </div>
         <div class="f-row-c config">
                 <!-- 版权信息 © {{config.copyright}}  -->
                <span @click="openUrl(1)" class="f-row-c pinter">
                    青ICP备{{config.icpInternetNo}}
                    <img class="foot-1" src="../../assets/img/foot-1.png"/>
                </span>
                <span @click="openUrl(2,config.publicNetInternetNo)" class="f-row-c pinter">
                    青公网安备{{config.publicNetInternetNo}}
                </span>
         </div>
    </div>
</template>

<script>
import queryHomeData from '@/axios/api'
export default {
    data() {
        return {
            config:{},
        };
    },
    created(){
        this.queryHomeData();
    },
    mounted() {

    },

    methods: {
        openUrl(type,code){
            window.open(type==1?'https://beian.miit.gov.cn/#/Integrated/index':'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+code)
        },
         queryHomeData(){
            this.$get('/web/home/queryBottom').then(res=>{
                this.config=res.result;
                // console.log(66,this.info)
            })
         },
    },
};
</script>

<style lang="scss" scoped>
.text-l{
    text-align: left;
    margin-right: 100px;
}
.text-c{
    text-align: center;
}
.mr-3{
    margin-right: 30px;
}
.mt-1{
    margin-top: 10px;
}
.mt-05{
    margin-top: 12px;
}
.lin-h{
    line-height: 30px;
}
.mt1-05{
    margin-top: 5px;
}
.op-5{
    // opacity: 0.5;
}
.bg-black{
    background: #828282;
    color: #ffffff;
    font-size: 16px;
    padding-top: 30px;
    // min-height: 256px;
}
.footbox{
    width: 1200px;
    margin: auto;
    margin-bottom: 30px;
    color: #ffffff;
    .f-l .imgbox{
        margin-right: 20px;
    }
    .font-14{
        font-size: 14px;
    }
    .imgbox{
        height: 80px;
        overflow: hidden;
        img{
            max-width: 80px;
            max-height: 80px;
        }
    }
    .img1{
        height: 85px;
        width: 85px;

        img{
            max-width: 85px;
            max-height: 85px;
        }
    }
    .img2{
        width: 144px;
        height: auto;
        overflow: hidden;
        img{
            max-width: 144px;
            max-height: 51px;
        }
    }
    .border{
        height: 51px;
        width: 1px;
        // background: #ffffff;
        margin-right: 20px;
        margin-left: 10px;
    }

}
.config{
    background: rgba($color: #1B1B1B, $alpha: 0.32);
    padding: 5px 0 5px;
    font-size: 12px;
    color: rgba($color: #ffffff, $alpha: 0.5);
}
.foot-1{
    max-width: 25px;
    max-height: 25px;
    margin-left: 10px;
    margin-right: 5px;
}
</style>
